import { canCollect } from './consent'
import type { ClientEvent } from './events'
import { getDistinctId, getUserId } from './identity'
import { enqueue } from './queue'
import { getSessionId } from './session'
import { uuid } from './uuid'

export const EVENT_VERSION = 1

export function track(event: ClientEvent): void {
  try {
    if (!canCollect()) return
    const now = Date.now()
    const { name, ...rest } = event
    const userId = getUserId()
    enqueue({
      event_id: uuid(),
      event_name: name,
      event_version: EVENT_VERSION,
      occurred_at: new Date(now).toISOString(),
      distinct_id: getDistinctId(),
      session_id: getSessionId(now),
      ...(userId ? { user_id: userId } : {}),
      ...rest
    })
  } catch {
    // analytics must never break the app
  }
}
